import React from "react";
import Marquee from "react-fast-marquee";
import { useHistory, useParams } from "react-router";
import {
  useAppEventStatusMessageSelector,
  useAppIrStatusMessageSelector,
  useAppSiteHeaderSelector,
} from "src/_common/hooks/selectors/eventSelector";
import { RODEO_PAGE_NAME } from "src/_config";

const TopSection = ({ page }: any) => {
  const { eventId, performanceId, gameId } = useParams<any>();
  const history = useHistory();
  const siteHeader = useAppSiteHeaderSelector();
  const statusMessageSelector = useAppEventStatusMessageSelector();
  const irStatusMessageSelector = useAppIrStatusMessageSelector();

  const goBack = () => {
    history.goBack();
  };

  const gotoLeaderboardPage = () => {
    history.push(`/result/${eventId}` + (performanceId ? `/${performanceId}` : "") + (gameId ? `/${gameId}` : ""));
  };

  return (
    <section
      className={
        page == RODEO_PAGE_NAME.PAST_EVENT_LIST ||
        ((page == RODEO_PAGE_NAME.CMS ||
          page == RODEO_PAGE_NAME.MY_ACCOUNT ||
          page == RODEO_PAGE_NAME.TEAM_IMAGE ||
          page == RODEO_PAGE_NAME.EVENT_LIST ||
          // page == RODEO_PAGE_NAME.PAST_EVENT_LIST ||
          eventId) &&
          siteHeader == 1) ||
        page == RODEO_PAGE_NAME.MY_TEAM
          ? ""
          : "d-none"
      }
    >
      {(statusMessageSelector && statusMessageSelector[0]?.status_text && eventId) || irStatusMessageSelector ? (
        <div className="top-marquee-text">
          <div>
            <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="11.5398" cy="11.5397" r="11.5" fill="#3BB5A4" fillOpacity="0.1" />
              <circle cx="11.5398" cy="11.5397" r="5.36667" fill="#3BB5A4" />
            </svg>
          </div>
          {/* <Marquee speed={60} pauseOnHover={true}>
          <span style={{ marginLeft: window.innerWidth < 767 ? window.innerWidth : 767 }}>
            Coming Soon! Rodeo Event being held in Las Vegas this winter.
          </span>
        </Marquee> */}
          {statusMessageSelector && statusMessageSelector[0]?.status_text && eventId ? (
            <div className="status-bar-wrap">
              <Marquee pauseOnHover={true} speed={60}>
                <span>{statusMessageSelector[0]?.status_text}</span>
              </Marquee>
            </div>
          ) : irStatusMessageSelector ? (
            <div className="status-bar-wrap">
              <Marquee pauseOnHover={true} speed={60}>
                <span>{irStatusMessageSelector}</span>
              </Marquee>
            </div>
          ) : null}
        </div>
      ) : null}

      <div className="top-logo-panel">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex gap-3">
            {page != RODEO_PAGE_NAME.EVENT_LIST && (
              <a className="back-btn" onClick={goBack}>
                <i className="back-arrow" />
              </a>
            )}
            <div className="top-panel-logo">
              <img src="/images/logo.svg" alt="" />
            </div>
          </div>
          {/* {((eventId && performanceId) || (eventId && performanceId && gameId)) && */}
          {page != RODEO_PAGE_NAME.LEADERBOARD && eventId ? (
            <div className="trophy-icon-panel" onClick={gotoLeaderboardPage}>
              <i className="trophy-icon" />
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default TopSection;
